import { Tooltip } from "components/Tooltips/Tooltip";
import { useStyles } from "./styles";

interface Props {
  name: string;
  tierSetName: string;
  multiple?: boolean;
  size?: "medium" | "small";
}

const truncateString = (text: string, maxLength: number) =>
  `${text.substring(0, maxLength).trim()}...`;

export const TierDisplayName = ({
  name,
  tierSetName,
  multiple,
  size = "medium",
}: Props) => {
  const classes = useStyles({ size });
  const maxLength = multiple ? 12 : 24;

  const isNameToLong = name?.length > maxLength;
  const nameTruncated = isNameToLong ? truncateString(name, maxLength) : name;

  const isTierSetNameToLong = tierSetName?.length > maxLength;
  const tierSetnameTruncated = isTierSetNameToLong
    ? truncateString(tierSetName, maxLength)
    : tierSetName;

  return (
    <div className={classes.tierWrapper}>
      <Tooltip text={isNameToLong ? name : ""}>
        <span>{nameTruncated}</span>
      </Tooltip>
      <Tooltip text={isTierSetNameToLong ? tierSetName : ""}>
        <span className={classes.tierSetPill}>{tierSetnameTruncated}</span>
      </Tooltip>
    </div>
  );
};
